
if(document.body.clientWidth>768){ 
          setTimeout(()=>{
            var slideToggleTrans = function(element, display) {
              console.log(element)
              console.log(display)
              element.onclick=function(){
                if(element.className == 'self_subscribe' || element.className == 'bestsellers-more'){
                  scrollTo(0,0);
                } 
                    if(document.querySelector('.mailmunch-embedded-iframe')){
                      let brandingBtn= document.querySelector('.mailmunch-embedded-iframe').contentWindow.document.body.querySelector('.theme input.submit');
                      brandingBtn.style.cssText="font-weight:bolder"; 
                       var _iframe = document.querySelector('.mailmunch-embedded-iframe').contentWindow.document.body.querySelectorAll('.text p br');   //get iframe下的id
                        _iframe.forEach(function(ele){
                          ele.remove();
                        });
                      let branding= document.querySelector('.mailmunch-embedded-iframe').contentWindow.document.body.querySelector('.branding-container');
                      if (!!branding) {
                        branding.remove();
                      }
                        // document.getElementsByClassName('hiwonder-forms-widget').slideToggle();   
                         var eleMore = document.getElementsByClassName('hiwonder-forms-widget')[0];   
                        var display = eleMore.style.height;
                          eleMore && (eleMore.style.height = display=='0px' || display=='' ? (function() {
                          var height = 0;
                          Array.prototype.slice.call(eleMore.childNodes).forEach(function(child){
                          if (child.nodeType === 1) {
                            var oStyle = window.getComputedStyle(child);
                            height = child.clientHeight + (parseInt(oStyle.borderTopWidth) || 0) + (parseInt(oStyle.borderBottomWidth) || 0);
                          }
                          });
                          return height;
                          })() + "px": "0px"); 
                    }
                  };
            }
                  // 应用渐进使用transition交互的slideToggle效果
                  slideToggleTrans(document.querySelector('.topbar-items .tb-item-text'));
                  slideToggleTrans(document.querySelector('.close-forms-widget'));
                  slideToggleTrans(document.querySelector('.self_subscribe'));
                  
                  // document.getElementsByClassName('hiwonder-forms-widget-footer').remove();
                  document.getElementsByClassName('header_Subscribe-footer').onclick=function(){
                    if(!!document.querySelector('.mailmunch-embedded-iframe')){
                              document.getElementsByClassName('hiwonder-forms-widget').show(); 
                              document.documentElement.scrollTop=document.documentElement.body=0;
                    };
                };
        	},4000);
}else {
    setTimeout(()=>{
        document.getElementsByClassName('branding-container').remove();
    },4000)
}
console.log('hiwonder.js')